/**
 * Event names that already reach ProductEventsTable through the server-side Discord chokepoint
 * (server/discord/enqueue-discord-signal.ts, fired from the API route that actually performed the
 * action). trackEvent() (analytics.ts) must NOT also beacon these — that would double-write the
 * same logical action once per side (client "I clicked save" + server "I actually saved it").
 * Everything else trackEvent() sees gets the new /api/track-event beacon (track-event-beacon.ts).
 *
 * job_save is here but its sibling job_unsave is NOT: unsave currently fires no server signal at
 * all, so it needs the beacon despite looking like save's counterpart. company_bulk_follow is also
 * NOT here even though company_follow is: the client fires one aggregate event while the server
 * fires N individual company_follow signals (one per company) — different eventKeys, not a
 * duplicate of each other, so the aggregate row is wanted too.
 */
export const CHOKEPOINT_COVERED_EVENT_NAMES = new Set<string>([
  "job_save",
  "company_follow",
  "company_unfollow",
  "role_follow",
  "role_unfollow",
  "saved_search_create",
  "job_alert_subscription_change",
  "saved_search_alert_toggle",
  "profile_field_change",
  "application_kit_interaction",
  "job_pipeline_stage_change",
  "feedback_submit",
  "account_created",
]);
